import { Injectable } from '@angular/core';
import { HttpService } from '../../../../shared/services/http/http-client.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class ModalAprovarPixService {
  protected urlBase = environment.url_server;

  constructor(private http: HttpService) { }

  aprovarReprovar(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doPost('/limite-pix/avaliar',data, successHandle, errorHandle);

  }

  aprovacaoPix(data: any, successHandle: Function, errorHandle: Function) {

    this.http.doGet('/limite-pix/pedidos-aumento',data, successHandle, errorHandle);

  }
}
